import React from 'react';
import { Icon } from './Icon.js';
export const IconCompass3 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M8.49995 8.49998L11 17.5H11.2895L13.5 13.5L17.5 11.2895L17.5 11L8.49995 8.49998Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconCompass3.js.map